export enum ButtonTypeEnum {
	Simple = 'Simple',
	Icon = 'Icon'
	// Dropdown = 'Dropdown' // will be used as a different component
}
